// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1XAne","overflowing":"ReadFullNote_overflowing__3bRIA"};